import { render, staticRenderFns } from "./conversations.vue?vue&type=template&id=2c82c901&scoped=true"
import script from "./conversations.vue?vue&type=script&lang=js"
export * from "./conversations.vue?vue&type=script&lang=js"
import style0 from "./conversations.vue?vue&type=style&index=0&id=2c82c901&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c82c901",
  null
  
)

export default component.exports